import * as React from 'react';
import { PassengerSwitch } from '../../../Passenger/components/Field/PassengerSwitch/PassengerSwitch';
const GenderSwitch = props => {
    return (React.createElement(PassengerSwitch, { name: 'sex', className: props.className, value: props.value, options: [
            { label: 'male', value: 'Male' },
            { label: 'female', value: 'Female' }
        ], onChange: value => props.onChange(value), onBlur: props.onBlur, error: props.error || null }));
};
export default GenderSwitch;
